module.exports = __webpack_public_path__ + "img/bowl.be5030ca.webp";